module.exports = __webpack_public_path__ + "static/media/taxijoin_02.319d1f58.png";